import { Popover, Table, Tag } from "antd";
import React from "react";
import { CardBody } from "reactstrap";

const UploadResultTable = ({ data }) => {
  const columns = [
    {
      title: "Item",
      key: "item",
      render: (data) => (
        <span>{data?.boq_sub_item ? data?.boq_sub_item : data?.boq_item}</span>
      ),
    },
    {
      title: "Status",
      key: "insert_status",
      render: (data) => (
        <span>
          {data?.insert_status ? (
            <Tag color={"success"}>Uploaded</Tag>
          ) : (
            <Popover
              content={data?.insert_message}
              title="Reason"
              trigger="hover"
            >
              <Tag style={{ cursor: "pointer" }} color={"error"}>
                Upload Failed
              </Tag>
            </Popover>
          )}
        </span>
      ),
    },
  ];
  return (
    <CardBody>
      <Table dataSource={data} columns={columns} />
    </CardBody>
  );
};

export default UploadResultTable;
